import {Component} from '@angular/core';
import {SpinnerService} from "./spinner.service";
@Component({
    selector: 'oa-spinner-component',
    'template': '<div *ngIf="active" class="spinner loading"></div>'
})
export class SpinnerComponent {
    public active: boolean;

    public constructor(spinner: SpinnerService) {
        spinner.status.subscribe((status: boolean) => {
            this.active = status;
        });
    }
}



// WEBPACK FOOTER //
// ./src/app/common/spinner/spinner.component.ts